__webpack_require__.p = "https://statics.gotyche.me/admin/1.32.5/";